import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

import {tokens as dark} from '../../../generated/dark';
import {tokens as light} from '../../../generated/light';
import {inputTheme} from '../../Input/theme';
import {textTheme} from '../../Text/theme';

import {parts, selectAnatomy} from './anatomy';

const {defineMultiStyleConfig, definePartsStyle} = createMultiStyleConfigHelpers(selectAnatomy.keys());

const lightTokens = light.components;
const darkTokens = dark.components;
const {
  components: {[`context-menu`]: contextMenu},
} = lightTokens;
const {
  components: {[`context-menu`]: contextMenuDark},
} = darkTokens;

const menuList = defineStyle(props => {
  return {
    display: `flex`,
    flexGrow: 1,
    height: `100%`,
    width: `100%`,
    overflowY: `auto`,
    overflowX: `hidden`,
    alignSelf: `stretch`,
    justifySelf: `stretch`,
    flexDirection: `column`,

    backgroundColor: mode(contextMenu[`background-default`], contextMenuDark[`background-default`])(props),
    padding: `0`,

    boxShadow: `xxl`,
    borderRadius: `radius-200`,
    overflow: `hidden`,

    [`& ${parts.option.selector}[data-last]`]: {
      borderBottomRadius: `radius-100`,
    },
    [`& ${parts.option.selector}[data-first]`]: {
      borderTopRadius: `radius-100`,
    },
  };
});

const option = defineStyle(props => {
  return {
    display: `flex`,
    gap: `space-100`, // TODO: fix token on Figma
    alignSelf: `stretch`,
    alignItems: `center`,

    // Styling
    backgroundColor: mode(contextMenu[`background-default`], contextMenuDark[`background-default`])(props),
    color: mode(contextMenu[`text-default`], contextMenuDark[`text-default`])(props),
    // Typography
    ...(textTheme.baseStyle?.(props) ?? {}),
    ...textTheme.sizes?.md,

    _selected: {
      backgroundColor: mode(contextMenu[`background-selected`], contextMenuDark[`background-selected`])(props),
    },

    _hover: {
      backgroundColor: mode(contextMenu[`background-hover`], contextMenuDark[`background-hover`])(props),
    },

    _active: {
      backgroundColor: mode(contextMenu[`background-pressed`], contextMenuDark[`background-pressed`])(props),
      color: mode(contextMenu[`text-active`], contextMenuDark[`text-active`])(props),
    },

    _focus: {
      backgroundColor: mode(contextMenu[`background-selected`], contextMenuDark[`background-selected`])(props),
    },

    _disabled: {
      backgroundColor: mode(contextMenu[`background-disabled`], contextMenuDark[`background-disabled`])(props),
      color: mode(contextMenu[`text-disabled`], contextMenuDark[`text-disabled`])(props),
      cursor: `not-allowed`,
    },

    // Transitions
    transition: `background-color 0.1s ease-in-out`,
  };
});

const control = defineStyle(props => {
  return {
    ...inputTheme.baseStyle?.(props).field,
    paddingRight: `space-100`,
  };
});

const baseStyle = definePartsStyle(props => ({
  option: option(props),
  control: control(props),
  menuList: menuList(props),
}));

export const selectTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    legacy: definePartsStyle({
      menuList: {
        paddingTop: `0`,
        paddingBottom: `0`,
      },
    }),
  },
  sizes: {
    sm: definePartsStyle({
      option: {},
      control: {
        ...inputTheme.sizes?.sm.field,
        borderRadius: `radius-100`,
      },
      menuList: {},
    }),
    md: definePartsStyle({
      option: {},
      menuList: {},
    }),
  },
});
